var boostPFSFilterConfig = {
	general: {
		limit: boostPFSThemeConfig.custom.products_per_page,
		/* Optional */
		loadProductFirst: true,
//         addCollectionToProductUrl: false,
// 		filterTreeMobileStyle: 'style1',
//       	urlScheme: 1,
      	capitalizeFilterOptionValues: false,
  	},
};

var boostPFSTemplate = {
	'saleClass': 'on-sale',
	'soldOutClass': 'sold-out',
	'blockLayoutClass': 'ft ftw ft-nm',

	'saleLabelHtml': '<span class="product-label product-label--sale"><span>' + boostPFSConfig.label.sale + '</span></span>',
	'soldOutLabelHtml': '<span class="product-label product-label--soldout"><span>' + boostPFSConfig.label.soldout + '</span></span>',

	// Grid Template
	'productGridItemHtml':  '<div data-boost-theme-quickview="{{itemId}}" class="product-block {{soldOutClass}} flex column {{maxColsClass}} min-cols-2 {{itemGridWidthClass}}">' +
								'<div class="image {{imageHoverClass}}">' +
									'<div class="inner">' +
										'<a href="{{itemUrl}}">' +
											'{{itemImg}}' +
										'</a>' +
										'{{itemQuickView}}' +
									'</div>' +
									'{{itemLabels}}' +
								'</div>' +

								'<div class="{{blockLayoutClass}}">' +
									'<div class="ftr">' +
										'<a class="title ftc" href="{{itemUrl}}">{{itemTitle}}{{itemVendor}}</a>' +
  										'<div data-bv-show="inline_rating" data-bv-product-id="{{itemId}}" data-bv-redirect-url="{{itemUrl}}" data-bv-seo="false"></div>' +
										'<div class="price ftc {{saleClass}}">{{itemPrice}}</div>' +
									'</div>' +
								'</div>' +
								'<div class="themed-product-reviews">' +
									'<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>' +
								'</div>' +
							'</div>',

	// Pagination Template
	'previousActiveHtml': '<li><a href="{{itemUrl}}" class="prev"><svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"> <title>Left</title> <path d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"/><path d="M0-.5h24v24H0z" fill="none"/> </svg></a></li>',
	'previousDisabledHtml': '<li><span class="linkless prev"><svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"> <title>Left</title> <path d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"/><path d="M0-.5h24v24H0z" fill="none"/> </svg></span></li>',
	'nextActiveHtml': '<li><a href="{{itemUrl}}" class="next"><svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"> <title>Right</title> <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"/><path d="M0-.25h24v24H0z" fill="none"/> </svg></a></li>',
	'nextDisabledHtml': '<li><span class="linkless next"><svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"> <title>Right</title> <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"/><path d="M0-.25h24v24H0z" fill="none"/> </svg></span></li>',
	'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
	'pageItemSelectedHtml': '<li class="active"><span class="linkless">{{itemTitle}}</span></li>',
	'pageItemRemainHtml': '<li><span class="linkless">{{itemTitle}}</span></li>',
	'paginateHtml': '<ul class="pagination">{{previous}}{{pageItems}}{{next}}</ul>',

	// Sorting Template
	'sortingHtml': '<label for="boost-pfs-filter-top-sorting-select">Sorting' + ':</label><div class="pretty-select id-sort-by"><select class="boost-pfs-filter-top-sorting-select sort-by">{{sortingItems}}</select><span class="text"><span class="value">{{itemLabelActive}}</span></span><svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"></path><path d="M0-.75h24v24H0z" fill="none"></path></svg></div>',
};

(function() {

	BoostPFS.inject(this);
  
	/************************** BUILD PRODUCT LIST **************************/
	// Build Product Grid Item
  	ProductGridItem.prototype.compileTemplate = function(data, index, totalProduct) {
      	if (!data) data = this.data;
      	if (!index) index = this.index + 1;
      	if (!totalProduct) totalProduct = this.totalProduct;
      
        /*** Prepare data ***/
        var images = data.original_images || data.images_info;
         // Displaying price base on the policy of Shopify, have to multiple by 100
        var soldOut = !data.available; // Check a product is out of stock
        var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
        var priceVaries = data.price_min != data.price_max; // Check a product has many prices
        // Get First Variant (selected_or_first_available_variant)
        var firstVariant = data['variants'][0];
        if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
            var paramVariant = data.variants.filter(function(e) { return e.id == Utils.getParam('variant'); });
            if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
        } else {
            for (var i = 0; i < data['variants'].length; i++) {
                if (data['variants'][i].available) {
                    firstVariant = data['variants'][i];
                    break;
                }
            }
        }
        /*** End Prepare data ***/

        // Get Template
        var itemHtml = boostPFSTemplate.productGridItemHtml;

        // Add soldOut class
        var soldOutClass = soldOut && boostPFSConfig.custom.label_soldout_enable ? boostPFSTemplate.soldOutClass : '';
        itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

        // Add maxColsClass
        itemHtml = itemHtml.replace(/{{maxColsClass}}/g, 'max-cols-' + boostPFSConfig.custom.products_per_row);

        // Add itemGridWidthClass
        var itemGridWidthClass = ''
        if (index % 2 == 1) { itemGridWidthClass += 'nth-2 '; }
        if (index % 3 == 1) { itemGridWidthClass += 'nth-3 '; }
        if (index % 4 == 1) { itemGridWidthClass += 'nth-4 '; }
        if (index % 6 == 1) { itemGridWidthClass += 'nth-6 '; }
        itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);

        // Add Block layout class
        var blockLayoutClass = boostPFSConfig.custom.block_layout == 'beside' ? boostPFSTemplate.blockLayoutClass : '';
        itemHtml = itemHtml.replace(/{{blockLayoutClass}}/g, blockLayoutClass);

        // Add image hover class
        var imageHoverClass = boostPFSConfig.custom.product_grid_hover_image && images.length > 1 ? 'image--with-secondary' : '';
        itemHtml = itemHtml.replace(/{{imageHoverClass}}/g, imageHoverClass);

        // Add price
        var itemPriceHtml = '';
        var saleClass = onSale ? boostPFSTemplate.saleClass : '';
        if (priceVaries) {
            itemPriceHtml += boostPFSConfig.label.from_price + ' ';
        }
        itemPriceHtml += '<span class="amount theme-money">' + Utils.formatMoney(data.price_min, Globals.moneyFormat) + '</span>';
        if (onSale) {
            itemPriceHtml += ' <del><span class="theme-money">' + Utils.formatMoney(data.compare_at_price_min, Globals.moneyFormat) + '</span></del>';
        }
        itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
        itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

        // Add vendor
        var itemVendorHtml = boostPFSConfig.custom.grid_show_vendor ? '<div class="vendor">'+ data.vendor +'</div>' : '';
        itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

        // Add Labels
        var itemLabelsHtml = '';
        if (onSale && boostPFSConfig.custom.label_sale_enable) {
            itemLabelsHtml += boostPFSTemplate.saleLabelHtml;
        } else if (boostPFSConfig.custom.label_remain_show && data.variants.length == 1 && data.variants[0].inventory_quantity > 0 && data.variants[0].inventory_quantity <= boostPFSConfig.custom.prod_stock_warn_limit) {
            itemLabelsHtml += '<span class="product-label general"><span>' + boostPFSConfig.label.only_x_left.replace(/{{ quantity }}/g, data.variants[0]['inventory_quantity']) + '</span></span>';
        } else {
            if (soldOut && boostPFSConfig.custom.label_soldout_enable) {
                itemLabelsHtml += boostPFSTemplate.soldOutLabelHtml;
            } else {
                for (var k in data.tags) {
                    var tag = data['tags'][k];
                    if (tag.indexOf('meta-label-') > -1) {
                        itemLabelsHtml += '<span class="product-label general"><span>' + tag.replace('meta-label-', '') + '</span></span>';
                    }else if (tag.indexOf('pfs:label-') > -1) {
                      if(tag.replace('pfs:label-', '') == 'new'){
                        itemLabelsHtml += '<span class="product-label-New "><span>' + tag.replace('pfs:label-', '') + '</span></span>';
                      }else {
                        itemLabelsHtml += '<span class="product-label general"><span>' + tag.replace('pfs:label-', '') + '</span></span>';
                      }
                    }
                }
            }
        }
        itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);

        // Add Quickview
        var itemQuickViewHtml = '';
        if (boostPFSConfig.custom.prod_quick_buy_show) {
            itemQuickViewHtml += '<div class="quick-buy-wrap pos-' + boostPFSConfig.custom.prod_quick_buy_pos + '">';
            itemQuickViewHtml += '<a class="quick-buy ';
            itemQuickViewHtml += boostPFSConfig.custom.prod_quick_buy_pos == 'middle' ? 'giant' : 'big';
            itemQuickViewHtml += '-round-button" href="{{itemUrl}}"><span>' + boostPFSConfig.label.quick_view + '</span></a>';
            itemQuickViewHtml += '</div>';
        }
        itemHtml = itemHtml.replace(/{{itemQuickView}}/g, itemQuickViewHtml);

        //Add Image
      	var variant = data.variants.find(function(e){return e.id == data.variant_id});
        var itemImgHtml = '';
        var aspectRatio = images.length > 0 ? images[0].width / images[0].height : 1;
        var maxWidth = images.length > 0 ? images[0].width : 480;
      	var mainImage = (typeof data.variant_id != 'undefined') ? variant.image : images[0].src;
        itemImgHtml += '<div class="product--image__primary">';
        itemImgHtml += '<img id="prod-' + data.variant_id + '" src="' + Utils.optimizeImage(mainImage, '1024x1024') + '" alt="' + mainImage.alt + '">';
        if (boostPFSConfig.custom.product_grid_hover_image && images.length > 1) {
            var aspect_ratio = images[1].width / images[1].height;
          	var secondImage = (typeof data.variant_id != 'undefined') ? images.find(function(e){return e.alt == variant.title && e.src != variant.image}) : images[1];
            if(typeof(secondImage) !== 'undefined'){
              itemImgHtml += '<img class="secondary__image" src="' + Utils.optimizeImage(secondImage.src, '1024x1024') + '" alt="' + secondImage.alt + '" />';
            }
        }
        itemImgHtml += '</div>';
        itemHtml = itemHtml.replace(/{{itemImg}}/g, itemImgHtml);

        // Add main attribute
        itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
        itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
        itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
        itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(data));

        return itemHtml;
    }

	/************************** END BUILD PRODUCT LIST **************************/
	function buildReview(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_product_review') &&
			boostPFSThemeConfig.custom.show_product_review == true) {
			html = '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>';
		}
		return html;
	}
  
  	function bgset(image) {
        var bgset = '';
        if (image) {
            var aspect_ratio = image.width / image.height;

            if (image.width > 180) bgset += ' ' + Utils.optimizeImage(image.src, '180x') + ' 180w ' + Math.round(180 / aspect_ratio) + 'h,';
            if (image.width > 360) bgset += ' ' + Utils.optimizeImage(image.src, '360x') + ' 360w ' + Math.round(360 / aspect_ratio) + 'h,';
            if (image.width > 540) bgset += ' ' + Utils.optimizeImage(image.src, '540x') + ' 540w ' + Math.round(540 / aspect_ratio) + 'h,';
            if (image.width > 720) bgset += ' ' + Utils.optimizeImage(image.src, '720x') + ' 720w ' + Math.round(720 / aspect_ratio) + 'h,';
            if (image.width > 900) bgset += ' ' + Utils.optimizeImage(image.src, '900x') + ' 900w ' + Math.round(900 / aspect_ratio) + 'h,';
            if (image.width > 1080) bgset += ' ' + Utils.optimizeImage(image.src, '1080x') + ' 1080w ' + Math.round(1080 / aspect_ratio) + 'h,';
            if (image.width > 1296) bgset += ' ' + Utils.optimizeImage(image.src, '1296x') + ' 1296w ' + Math.round(1296 / aspect_ratio) + 'h,';
            if (image.width > 1512) bgset += ' ' + Utils.optimizeImage(image.src, '1512x') + ' 1512w ' + Math.round(1512 / aspect_ratio) + 'h,';
            if (image.width > 1728) bgset += ' ' + Utils.optimizeImage(image.src, '1728x') + ' 1728w ' + Math.round(1728 / aspect_ratio) + 'h,';
            if (image.width > 1950) bgset += ' ' + Utils.optimizeImage(image.src, '1950x') + ' 1950w ' + Math.round(1950 / aspect_ratio) + 'h,';
            if (image.width > 2100) bgset += ' ' + Utils.optimizeImage(image.src, '2100x') + ' 2100w ' + Math.round(2100 / aspect_ratio) + 'h,';
            if (image.width > 2260) bgset += ' ' + Utils.optimizeImage(image.src, '2260x') + ' 2260w ' + Math.round(2260 / aspect_ratio) + 'h,';
            if (image.width > 2450) bgset += ' ' + Utils.optimizeImage(image.src, '2450x') + ' 2450w ' + Math.round(2450 / aspect_ratio) + 'h,';
            if (image.width > 2700) bgset += ' ' + Utils.optimizeImage(image.src, '2700x') + ' 2700w ' + Math.round(2700 / aspect_ratio) + 'h,';
            if (image.width > 3000) bgset += ' ' + Utils.optimizeImage(image.src, '3000x') + ' 3000w ' + Math.round(3000 / aspect_ratio) + 'h,';
            if (image.width > 3350) bgset += ' ' + Utils.optimizeImage(image.src, '3350x') + ' 3350w ' + Math.round(3350 / aspect_ratio) + 'h,';
            if (image.width > 3750) bgset += ' ' + Utils.optimizeImage(image.src, '3750x') + ' 3750w ' + Math.round(3750 / aspect_ratio) + 'h,';
            if (image.width > 4100) bgset += ' ' + Utils.optimizeImage(image.src, '4100x') + ' 180w ' + Math.round(4100 / aspect_ratio) + 'h,';
            bgset += ' ' + image.src + ' ' + image.width + 'w ' + image.height + 'h,';
        }
        return bgset;
    }


	/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
	/************************** BUILD TOOLBAR **************************/
	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}

		var paginationHtml = boostPFSTemplate.paginateHtml;
		// Build Previous
		var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
		// Build Next
		var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);
		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}
		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
      
		return paginationHtml;
	};
  
//   	ProductPaginationDefault.prototype._onClickEvent = function(event) {
// 		event.preventDefault();
// 		Globals.internalClick = true;

// 		// Get the new page value
// 		var url;
// 		try {
// 			url = new URL(jQ(event.currentTarget).attr('href'));
// 		} catch (e) {
// 			url = new URL('https://' + boostPFSConfig.shop.domain + jQ(event.currentTarget).attr('href'));
// 		}

// 		var pageValue = url && url.searchParams ? url.searchParams.get('page') : 1;
// 		if (!pageValue || isNaN(pageValue)) pageValue = 1;

// 		// Apply filter
// 		FilterApi.setParam('page', pageValue);
// 		FilterApi.applyFilter('page');
      
// 		// Scroll to top of product list
// 		theme.viewport.scrollTo({
// 			top: this.$productList.offset().top - 50,
// 			behavior: 'smooth'
// 		});
// 	}

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
                // Build content 
                var sortingItemsHtml = '';
                for (var k in sortingArr) {
                    sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
                }
                var html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
                html = html.replace(/{{itemLabelActive}}/g, sortingArr[Globals.queryParams.sort]);
            }
		}
		return html;
	};

	/************************** END BUILD TOOLBAR **************************/

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data) {
		if (!data) data = this.data;

		// Intergrate Review Shopify
		if (window.SPR &&
			typeof window.SPR.initDomEls == 'function' &&
			typeof window.SPR.loadBadges == 'function' &&
			boostPFSThemeConfig.custom.show_product_review) {
			window.SPR.initDomEls();
			window.SPR.loadBadges();
		}
      
//       	var html = '<div class="product-block product-block--flex-spacer flex column max-cols-' + boostPFSThemeConfig.custom.products_per_row + ' min-cols-' + boostPFSThemeConfig.custom.mobile_products_per_row + '"></div>';
//       	for (var i = 0; i < boostPFSThemeConfig.custom.products_per_row; i++) {
//           	jQ(Selector.products).append(html);
//         }
      	
	};

	// Build additional elements
	Filter.prototype.afterRender = function(data) {
		if (!data) data = this.data;

		jQ('.results-count').html(boostPFSThemeConfig.label.products_count.replace(/{{ count }}/g, data.total_product));
      
//       	theme.Sections.init();
//         theme.Sections.register('collection-template', theme.CollectionTemplateSection, {
//           deferredLoad: false
//         });
      
//         jQ('.boost-pfs-filter-toggle').off('click').on('click', function(e) {
//           e.preventDefault();
//           jQ('.collection-page').removeClass('cc-filters-closed-no-trans');
          
//           if (theme.viewport.isXs()) {
//             jQ('.collection-page').toggleClass('cc-filters-mob-open');
//           } else {
//             jQ('.collection-page').toggleClass('cc-filters-closed');
//           }
//       	});
      
//       	jQ('.boost-pfs-filter-close').off('click').on('click', function() {
//           jQ('.collection-page').removeClass('cc-filters-mob-open');
//       	});      	
      
//       	if (Utils.isMobile() && boostPFSFilterConfig.general.filterTreeMobileStyle == 'style1') {
//             jQ('body').addClass('boost-pfs-filter-tree-open-body');
//         }
	};
  
//   	FilterScrollToTop.prototype.scrollToTop = function() {
// 		theme.viewport.scrollTo({
// 			top: 0,
// 			behavior: 'smooth'
// 		});
// 	}
})();